import { utility, Button } from '@phi/components';
import { defineComponent, h } from 'vue';
import { FormText } from '../form-text';
import { isEnter } from '@frontend/keyboard';

export const FormTextSubmit = defineComponent({
    props: {
        button: {
            required: false,
            type: String,
            default: 'Submit',
        },
    },

    emits: {
        submit: (x: string) => true,
    },

    data() {
        return { text: '' };
    },

    methods: {
        submit() {
            if (!this.text) return;
            this.$emit('submit', this.text);
            this.text = '';
        },

        onKeydown(x: KeyboardEvent) {
            if (isEnter(x))
                this.submit();
        },
    },

    render() {
        return h('div', {
            class: [
                'form-text-submit',
                [utility.flex],
                [utility.gap_1],
            ],
        }, [
            h(FormText, {
                value: this.text,
                'onUpdate:value': x => this.text = x,
                onKeydown: this.onKeydown,
                class: utility.flexible,
            }),

            h(Button, { onClick: this.submit }, () => this.button),
        ]);
    },
});
